module.exports = __webpack_public_path__ + "static/img/928_phase_function_Paper_Points.027db14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/928_phase_function_Paper_Points.png
// module id = dMqF
// module chunks = 0